import useApiController from "@hooks/useApiController";

export default function useParticipationController(): Customer.Controllers.Participation {
    const { destroy, ...controller } = useApiController("/api/customer/participations")

    const store = (salonId: string | number, sectionId: string | number, photoId: string | number) => controller.post(`${salonId}/${sectionId}/${photoId}`)

    return { store, destroy }
}